.stage-container {
    display: flex;
    min-width: 100px;
    width: 100%;
    padding: 0;
    text-overflow: hidden;

    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--blue-lt);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: var(--tag-blue);
        }
    }
}

.stage-container--display-only {
    cursor: default;
    pointer-events: none;
}

.stage-container--active,
.stage-container--current {
    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--blue);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: var(--blue-dk);
        }
    }
}

/* Hot state styles */
.stage-container--hot {
    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--orange-lt);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: var(--tag-orange);
        }
    }
}

.stage-container--hot.stage-container--active,
.stage-container--hot.stage-container--current {
    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--orange);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: #e55000;
        }
    }
}

/* Won status styles */
.stage-container--won {
    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--green-lt);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: var(--green-lt);
        }
    }
}

.stage-container--won.stage-container--active,
.stage-container--won.stage-container--current {
    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--green-dk);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: var(--green-dk);
        }
    }
}

/* Inactive status styles */
.stage-container--inactive {
    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--off-white);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: var(--off-white);
        }
    }
}

.stage-container--inactive.stage-container--active,
.stage-container--inactive.stage-container--current {
    .stage-left::before,
    .stage-left::after,
    .stage-center,
    .stage-right::before,
    .stage-right::after {
        background-color: var(--off-white-dk);
    }

    &:hover:not(.stage-container--current):not(.stage-container--display-only) {
        .stage-left::before,
        .stage-left::after,
        .stage-center,
        .stage-right::before,
        .stage-right::after {
            background-color: var(--off-white-dk);
        }
    }
}

/* Left side styles */
.stage-left {
    display: flex;
    flex-direction: column;

    &::before {
        content: '';
        height: 15px;
        width: 10px;
        transform: skew(20deg);
        box-sizing: border-box;
    }

    &::after {
        content: '';
        height: 15px;
        width: 10px;
        transform: skew(-20deg);
        box-sizing: border-box;
    }
}

/* Center bar styles */
.stage-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 100%;
    margin-left: -3px;
    margin-right: -3px;
    box-sizing: border-box;
    padding-left: 8px;
    padding-right: 8px;
    overflow: hidden;
}

.stage-center--small {
    height: 24px;
    padding-left: 6px;
    padding-right: 6px;
}

.stage-center--start {
    margin-left: initial;
}

.stage-center--end {
    margin-right: initial;
}

.stage-right {
    display: flex;
    flex-direction: column;

    &::before {
        content: '';
        height: 15px;
        width: 10px;
        transform: skew(20deg);
        box-sizing: border-box;
    }

    &::after {
        content: '';
        height: 15px;
        width: 10px;
        transform: skew(-20deg);
        box-sizing: border-box;
    }
}

.stage-container--small .stage-left::before,
.stage-container--small .stage-left::after,
.stage-container--small .stage-right::before,
.stage-container--small .stage-right::after {
    height: 12px;
    width: 6px;
}

/* Selected state styles */
.stage-container--selected {
    .stage-left {
        &::before {
            border-top: 2px solid var(--grey-dk);
            border-left: 2px solid var(--grey-dk);
        }

        &::after {
            border-bottom: 2px solid var(--grey-dk);
            border-left: 2px solid var(--grey-dk);
        }
    }

    .stage-center {
        border-bottom: 2px solid var(--grey-dk);
        border-top: 2px solid var(--grey-dk);
    }

    .stage-center--start {
        border-left: 2px solid var(--grey-dk);
    }

    .stage-center--end {
        border-right: 2px solid var(--grey-dk);
    }

    .stage-right {
        &::before {
            border-top: 2px solid var(--grey-dk);
            border-right: 2px solid var(--grey-dk);
        }

        &::after {
            border-bottom: 2px solid var(--grey-dk);
            border-right: 2px solid var(--grey-dk);
        }
    }
}
